import { EMPTY_RTE } from "../CustomTextArea/CustomRTE";

export const INITIAL_COURSE_REVIEW = {
  selectedReflections: [],
  reflectionsSummary: EMPTY_RTE,
  selectedActions: [],
  actionsSummary: EMPTY_RTE,
  results: {
    presentation_type: "line",
    lo_type: "CSLO",
    mastery_results: "true",
    terms: [],
    data: null,
  },
};

export function getCourseReviewSteps(t) {
  return [
    t("setup.dataInterpretationHeader"),
    t("reflections.reflections"),
    t("actions.actions"),
    t("courseReview.reviewAndPublish"),
  ];
}
